module.exports = __webpack_public_path__ + "img/logo-short.6d4db4c0.png";